<style lang="less" scoped>
.cardIcon {font-size: 50px; font-weight: bold;}
.card {display: inline-block; width: 80px; height: 80px; padding: 5px; text-align: center; cursor: pointer;}
.fileText {overflow: hidden;text-overflow: ellipsis;white-space: nowrap;
  span {font-size: 14px;color: white;}
}
</style>

<template>
  <div class="card" @click="onClick" @dblclick="onDbClick">
    <i class="cardIcon" :class="getFileIcon(file)" :style="{color: getFileColor(file)}"></i>
    <el-tooltip v-if="!file.children" effect="dark" :content="file.text" placement="top">
      <div class="fileText"><span>{{file.text}}</span></div>
    </el-tooltip>
    <div v-else class="fileText"><span>{{file.text}}</span></div>
  </div>
</template>

<script>
export default
{
  props:
  {
    file: Object
  },
  methods:
  {
    /**
     * 获取不同文件类型的图标
     * @method
     * @param   {Object}    file    文件属性对象
     * @returns {String}    图标样式
     */
    getFileIcon(file)
    {
      if (file.children)
        return 'el-icon-folder'
      let icons =
      [
        {types: ['PNG', 'JPG', 'JPEG', 'BMP', 'TIF', 'GIF'], icon: 'el-icon-picture'},
        {types: ['3GP', 'AVI', 'ASF', 'ASX', 'FLV', 'MOV', 'MPG', 'MP4', 'OGG', 'WEBM', 'WMV'], icon: 'el-icon-video-camera-solid'},
        {types: ['MP3', 'WAV'], icon: 'el-icon-video-microphone'},
        {types: ['TXT', 'DOC', 'DOCX', 'PPT', 'PPTX', 'XLS', 'XLSX', 'PDF'], icon: 'el-icon-document'}
      ]
      let icon = icons.find(item => item.types.indexOf(file.text.split('.').pop().toUpperCase()) !== -1)
      return icon ? icon.icon : 'el-icon-tickets'
    },
    /**
     * 获取文件的颜色
     * @method
     * @param   {Object}    file    文件属性对象
     * @returns {String}    颜色代码
     */
    getFileColor(file)
    {
      return file.children ? '#a3a347' : '#4cb8b4'
    },
    onClick()
    {
      this.$emit('click', this.file)
    },
    onDbClick()
    {
      this.$emit('dblclick', this.file)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/com/fileManage/FileCard.vue